import React from 'react'
import { Modal } from 'react-bootstrap'
import { List } from 'immutable'
import i18next from 'i18next'

import UnitDetailsWopi360AddModalForm from './UnitDetailsWopi360AddModalForm'

import wopi360Service from '../services/wopi360'

export default class UnitDetailsWopi360AddModal extends React.PureComponent {
  state = {
    targets: List(),
    pagination: null
  }

  componentDidMount() {
    this.getWopi360Targets(1)
  }

  handlePagination = page => {
    this.getWopi360Targets(page)
  }

  getWopi360Targets = page => {
    wopi360Service
      .searchWopi360Targets({
        organisationId: this.props.organisationId,
        filters: { status: 'all' },
        smallLimit: true,
        page
      })
      .then(res =>
        this.setState({
          targets: List(res.data.results),
          pagination: res.data.pagination
        })
      )
  }

  render() {
    const { targets, pagination } = this.state
    const { isVisible, handleClose, unitTargets, isUpdatingRelations } = this.props

    return (
      <Modal show={isVisible} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{i18next.t('unit_choose_360_targets_to_attach')}</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ borderRadius: 6 }}>
          <UnitDetailsWopi360AddModalForm
            targets={targets}
            pagination={pagination}
            unitTargets={unitTargets}
            isDisabled={isUpdatingRelations}
            onPaginate={this.handlePagination}
            onSubmit={this.props.onSubmit}
          />
        </Modal.Body>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnitDetailsWopi360AddModal.js